import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";
const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col xl:flex-row gap-10 lgl:gap-20"
    >
       {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            2011-2023
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
       
        <div
          className="mt-6 w-full h-[1100px] lgl:w-[550px] lgl:ml-20 border-l-[6px] border-black 
        border-opacity-30 flex flex-col gap-10"
        >
          <ResumeCard
            title="Bsc in Computer Network Engineering"
            subTitle="University of Malawi(UNIMA) (2018-2023)"
            results="Pending"
            des="The University of Malawi is the origin of all other universities in Malawi. 
            I began my academic career in 2018 and will soon complete it in June 2023."
          />
          <ResumeCard
            title="Certificate in Web Develop ment"
            subTitle="Microsoft & Google (2023)"
            results="First Class"
            des="DevTown, which stands for Development Town, is a 
            well-known ICT corporation in India. I enrolled in a web programming 
            course through DevTown and earned certifications from Microsoft and Google."
          />
          <ResumeCard
            title="Certificate in Networking"
            subTitle="Huawei Technologies (2022-2023)"
            results="First Class"
            des="A well-known tech company worldwide is Huawei Technologies. 
            I registered in networking courses such Routing & Switching,
             Network Security, and WLAN which allowed me to participate in
             the 2022–2023 ICT Competition."
          />
          <ResumeCard
            title="Certificate in Statistical Packages &
          Digital Collection Tools"
            subTitle="Supreme Research Institute(SRI) (2020)"
            results="First Class"
            des="I enrolled in this data analysis program during 
            the Covid-19 pandemic to expand my data analytic skills."
          />
        </div>
      </div>
      {/* part two */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4 lgl:mt-0 mt-20">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            2011-2023
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div
          className="mt-6 w-full lgl:w-[550px] lgl:h-[1100px] h-auto border-l-[6px] border-black 
         border-opacity-30 flex flex-col gap-10"
        >
          <ResumeCard
            title="Network Engineer"
            subTitle="University of Malawi (2018-2023)"
            results="Malawi"
            des="One of my biggest professional accomplishments has been
             learning Network Engineering at Universisty of Malawi. Lessons
              in theory and practice were being taught to us."
          />
          <ResumeCard
            title="Web & Mobile App Developer"
            subTitle="ZuzuTech (2020-Present)"
            results="Malawi"
            des="The technology company ZuzuTech is highly known in Malawi.
             Web design and hosting are its main areas of attention. 
             The creation of mobile apps and their availability on the
              Google Play store are further areas of concentration. 
            There is an app named ZuzuDiary app onn the Google Play Store."
          />
          <ResumeCard
            title="Graphic Designer"
            subTitle="Macheda Graphics (2018-Present)"
            results="Malawi"
            des="One of Malawi's top graphic design firms is Macheda Graphics.
            I am a senior graphic designer and a manager."
          />
          <ResumeCard
            title="Research Assistant"
            subTitle="Institute of Public Opinion & Reseach (IPOR) (2022)"
            results="Malawi"
            des="A reputable research organization is IPOR. In 2022, I took part in the 
            GESD study project by gathering information on Mzimba and Likoma Island."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Education;
